import * as React from "react"

const Content = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4 17a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 16V8q0-.424.288-.713A.97.97 0 0 1 4 7h8q.424 0 .713.287Q13 7.576 13 8v8q0 .424-.287.712A.97.97 0 0 1 12 17zm1-2h6V9H5zM4 5a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 4q0-.424.288-.712A.97.97 0 0 1 4 3h16q.424 0 .712.288Q21 3.575 21 4q0 .424-.288.713A.97.97 0 0 1 20 5zm12 4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 8q0-.424.287-.713A.97.97 0 0 1 16 7h4q.424 0 .712.287Q21 7.576 21 8q0 .424-.288.713A.97.97 0 0 1 20 9zm0 4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 12q0-.424.287-.713A.97.97 0 0 1 16 11h4q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 20 13zm0 4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 16q0-.424.287-.713A.97.97 0 0 1 16 15h4q.424 0 .712.287.288.288.288.713 0 .424-.288.712A.97.97 0 0 1 20 17zM4 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20q0-.424.288-.712A.97.97 0 0 1 4 19h16q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 20 21z" />
  </svg>
)
// eslint-disable-next-line import/no-default-export
export default Content
